module.exports = {
  activation: require('./methods/activation'),
  cost: require('./methods/cost'),
  methods: require('./methods/methods'),
  Connection: require('./architecture/connection'),
  architect: require('./architecture/architect'),
  Network: require('./architecture/network'),
  config: require('./config'),
  Group: require('./architecture/group'),
  Layer: require('./architecture/layer'),
  Node: require('./architecture/node'),
  Neat: require('./neat'),
  Population: require('./architecture/population'),
  GAN: require('./gan'),
  multi: require('./multithreading/multi'),
};
